import React, { useState } from 'react'
import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from '@mui/material/useMediaQuery'
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Popup from './Popup';
import ContactUs from "./ContactUs";
import TandC from './TandC';
import Privacy from "./Privacy";
import Refund from "./Refund";

const Footer = () => {
    const theme = useTheme();
    const smallFooter = useMediaQuery(theme.breakpoints.down('lg'));
    const [popupOpen, setPopupOpen] = useState(false);
    const [component, setComponent] = useState(null);
    const [title, setTitle] = useState('');

    const setDone = () => {
        setPopupOpen(false);
        setComponent(null);
        setTitle('');
    }

    const openPopup = (comp, popupTitle) => {
        setComponent(comp);
        setTitle(popupTitle);
        setPopupOpen(true);
    }

    const handleKeyDown = (event, comp, popupTitle) => {
        if (event.key === 'Enter' || event.key === ' ') {
            openPopup(comp, popupTitle);
        }
    }

    return (
        <>
            { popupOpen &&
                <Popup open={popupOpen} setDone={setDone} component={component} title={title} />
            }
            <Container maxWidth={false} sx={{marginTop: '.5rem', marginBottom: '1rem', textAlign: 'center'}}>
                <Grid container spacing={2}>
                    <Grid item xs={3}><Typography sx={{fontSize: `${smallFooter ? '.7rem' : '1rem'}`}}>
                        <Button onClick={() => openPopup(ContactUs, 'Help & Contact')} onKeyDown={(event) => handleKeyDown(event, ContactUs, 'Help & Contact')} sx={{textTransform: 'none', padding: '0', fontSize: 'inherit', color: 'primary.main', '&:hover': {textDecoration: 'underline'}}}>Help & Contact</Button>
                    </Typography></Grid>
                    <Grid item xs={3}><Typography sx={{fontSize: `${smallFooter ? '.7rem' : '1rem'}`}}>
                        <Button onClick={() => openPopup(TandC, 'Terms and Conditions')} onKeyDown={(event) => handleKeyDown(event, TandC, 'Terms and Conditions')} sx={{textTransform: 'none', padding: '0', fontSize: 'inherit', color: 'primary.main', '&:hover': {textDecoration: 'underline'}}}>Terms and Conditions</Button>
                    </Typography></Grid>
                    <Grid item xs={3}><Typography sx={{fontSize: `${smallFooter ? '.7rem' : '1rem'}`}}>
                        <Button onClick={() => openPopup(Refund, 'Refunds / Credits')} onKeyDown={(event) => handleKeyDown(event, Refund, 'Refunds / Credits')} sx={{textTransform: 'none', padding: '0', fontSize: 'inherit', color: 'primary.main', '&:hover': {textDecoration: 'underline'}}}>Refunds / Credits</Button>
                    </Typography></Grid>
                    <Grid item xs={3}><Typography sx={{fontSize: `${smallFooter ? '.7rem' : '1rem'}`}}>
                        <Button onClick={() => openPopup(Privacy, 'Privacy Policy')} onKeyDown={(event) => handleKeyDown(event, Privacy, 'Privacy Policy')} sx={{textTransform: 'none', padding: '0', fontSize: 'inherit', color: 'primary.main', '&:hover': {textDecoration: 'underline'}}}>Privacy Policy</Button>
                    </Typography></Grid>
                </Grid>
                <Grid container>
                    <Grid href="#" underline="always"  item xs={12} style={{textAlign: "center"}} ><Typography sx={{fontSize: `${smallFooter ? '.7rem' : '1rem'}`}}>© 2008-{`${new Date().getFullYear()}`} Justice Systems Inc.; Neumo LLC - All rights reserved.</Typography></Grid>
                </Grid>
            </Container>
        </>
    );
}

export default Footer
